export default {
  namespaced: true,

  state: {
    employee: {},
    defaults: {},
  },

  getters: {},

  mutations: {
    set(state, payload) {
      state.employee = payload;
    },
    setDefaults(state, payload) {
      state.defaults = payload;
    },
  },

  actions: {
    set({ commit }, payload) {
      commit('set', payload);
    },

    setDefaults({ commit }, payload) {
      commit('setDefaults', payload);
    },
  },
};
